<template>
    <ListeProfesseur/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    
    import ListeProfesseur from "@/components/Professeur/ListeProfesseur.vue";

    export default defineComponent({
      name: "ListeProfesseurPage",
      components: {
        
        ListeProfesseur,
      },
    });
  </script>